export class DocumentTypes {
    public DocumentTypeId: number;
    public DocumentTypeName: string;
    public DocumentType: number;
    public IsOtherDocument: boolean;
    public IsJointApplicantDocument: boolean;
    public IsCommunicationAddress: boolean;
    public Status: boolean;
}